export const escrowLayoutContentMap = {
  content: {
    title: 'Content Verification Report',
    subtitle: "An inspection and review of the deposited material's profile.",
    description:
      'A content overview helps assess the accuracy and relevance of the materials placed in escrow. This verification focuses on key elements such as the software’s size, the development team, and recent updates. Reviewing this information promotes transparency, supports risk management, and confirms compliance with the agreed-upon development terms.',
  },
  activity: {
    title: 'Activity Verification Report',
    subtitle: 'An inspection and review of development activity on the source code.',
    description:
      'Development activity offers insight into the project’s progression and the frequency of updates or modifications. This verification records the number of commits per month, capturing changes made to the material at a specific point in time. Monitoring these commits ensures that the deposited material reflects the current and active state of the software, providing interested parties with a reliable measure of ongoing development and maintenance efforts.',
  },
};

export const backupLayoutContentMap = {
  content: {
    title: 'Content Verification Report',
    subtitle: "An inspection and review of the backed-up material's profile.",
    description:
      'This content overview helps assess the accuracy and completeness of the materials being backed up. The verification focuses on key indicators such as repository size, active contributors, and recent development activity. Tracking this information supports operational visibility, aids disaster recovery planning, and confirms alignment with internal development standards.',
  },
  activity: {
    title: 'Activity Verification Report',
    subtitle: 'An inspection and review of development activity in the backed-up material.',
    description:
      "Development activity provides insight into the project's progression and the frequency of updates or modifications. This verification records the number of commits per month, capturing changes made to the repository at a specific point in time. Tracking this activity confirms that the backed-up asset reflects the current and active state of the software, supporting disaster recovery planning and operational continuity.",
  },
};
